export interface EventCard {
  id: string;
  category: string;
  title: string;
  summary: string;
  heat: string;
  time: string;
  status: string;
  image: string;
}

export const hotEvents: EventCard[] = [
  {
    id: 'e1',
    category: '社会热议',
    title: '活动现场的一段记录为何引爆全网讨论',
    summary: '一段被反复转发的现场记录，引发对事发经过、在场各方反应与后续处理的广泛追问，多条矛盾说法并存。',
    heat: '128.6万',
    time: '12小时前更新',
    status: '持续追踪',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20documentary%20photo%20style%20of%20a%20crowd%20gathering%20at%20a%20public%20square%20during%20an%20evening%20event%2C%20warm%20street%20lights%2C%20news%20photography%2C%20cinematic%2C%20muted%20warm%20tones%2C%20no%20faces%20closeup&width=800&height=520&seq=ev-card-01&orientation=landscape',
  },
  {
    id: 'e2',
    category: '公众人物',
    title: '一次公开表态引发的回应链条梳理',
    summary: '公众人物的一次表态被逐句拆解，随后多个层面的回应接连出现。我们按时间顺序整理了完整脉络与分歧点。',
    heat: '96.3万',
    time: '昨天',
    status: '真相待核',
    image: 'https://readdy.ai/api/search-image?query=Conceptual%20editorial%20image%20of%20a%20microphone%20on%20a%20podium%20in%20front%20of%20soft%20blurred%20audience%20lights%2C%20press%20conference%20atmosphere%2C%20warm%20journalistic%20tone%2C%20photorealistic&width=800&height=520&seq=ev-card-02&orientation=landscape',
  },
  {
    id: 'e3',
    category: '平台热点',
    title: '被截图的聊天记录能否作为完整证据',
    summary: '围绕一组广泛传播的聊天记录，讨论从"记录真假"延伸到"断章取义"与"信息语境"，我们汇总了专业角度的拆解。',
    heat: '75.8万',
    time: '2天前',
    status: '存疑讨论',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20smartphone%20chat%20screenshots%20and%20a%20magnifying%20glass%20on%20a%20desk%2C%20document%20forensic%20theme%2C%20warm%20desk%20light%2C%20clean%20composition%2C%20no%20text%20readable&width=800&height=520&seq=ev-card-03&orientation=landscape',
  },
  {
    id: 'e4',
    category: '舆论反转',
    title: '舆论几次反转背后的信息差',
    summary: '同一起事件在不同阶段呈现完全相反的印象，背后是信息发布节奏与语境的错位。我们还原了反转的关键节点。',
    heat: '63.1万',
    time: '3天前',
    status: '已梳理',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20concept%20image%20of%20two%20opposing%20arrow%20directions%20meeting%20at%20a%20junction%2C%20warm%20orange%20and%20cream%20tones%2C%20minimal%20editorial%20style%2C%20clean%20graphic&width=800&height=520&seq=ev-card-04&orientation=landscape',
  },
  {
    id: 'e5',
    category: '事件调查',
    title: '一次线下活动争议的调查进展汇总',
    summary: '围绕线下活动中的争议细节，各渠道的调查进展并不一致。我们按时间排列了每一次公开的进展与说明。',
    heat: '52.4万',
    time: '5天前',
    status: '调查中',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20clipboard%20with%20timeline%20notes%2C%20magnifying%20glass%20and%20coffee%20on%20a%20warm%20wooden%20desk%2C%20investigation%20theme%2C%20soft%20natural%20light%2C%20documentary%20style&width=800&height=520&seq=ev-card-05&orientation=landscape',
  },
  {
    id: 'e6',
    category: '辟谣专区',
    title: '被广泛转发的说法中哪些已被澄清',
    summary: '整理近期被误传的说法，逐一对照官方说明与可靠来源，标记"已被澄清""存疑"与"有待证实"三种状态。',
    heat: '41.7万',
    time: '1周前',
    status: '辟谣',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20editorial%20image%20of%20a%20stamp%20with%20correct%20mark%20and%20cancel%20mark%20on%20paper%20documents%2C%20fact%20check%20theme%2C%20warm%20neutral%20tones%2C%20clean%20flat%20lay&width=800&height=520&seq=ev-card-06&orientation=landscape',
  },
];